module.exports = __webpack_public_path__ + "assets/048b54ab22ffb00823522182494b85be.png";